var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$auth.check() && _vm.is_mobile)?_c('div',[_c('v-bottom-navigation',{attrs:{"value":_vm.activeBtn,"grow":"","color":"teal","app":""}},_vm._l((_vm.links.filter(l => l.active)),function(link,i){return _c('v-btn',{key:i,attrs:{"to":link.to}},[_c('v-icon')],1)}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }